__turbopack_context__.v({
  "fireworks": "Fireworks-module-scss-module__2uBbxG__fireworks",
});
